var map = {
	"./icon-1.png": "e076",
	"./icon-2.png": "d347",
	"./icon-3.png": "7cbc",
	"./icon-4.png": "d5c3",
	"./icon-5.png": "0037",
	"./icon-6.png": "11a5",
	"./icon-7.png": "3657",
	"./icon-coin.png": "9648",
	"./icon-family.png": "7eb7",
	"./icon-hospital.png": "b911",
	"./icon-monitor.png": "42a4",
	"./icon-phone.png": "be2a",
	"./icon-speech.png": "2bdf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d50";